import { api } from "../api/clientInstance";

export async function postLoginRedirect(navigate) {
  try {
    const team = await api("/user/team");
    if (!team || !team.id) {
      navigate("/team/create", { replace: true });
      return;
    }
    const readiness = await api("/players/ready");
    if (!readiness.ready) {
      navigate("/team/edit", { replace: true });
      return;
    }
  } catch {
    // If checks fail, fall through to dashboard
  }
  navigate("/dashboard", { replace: true });
}
